module.exports = __webpack_public_path__ + "img/industry_example_fr.090567ca.jpg";